import { useEffect } from 'react';
import { useAlert } from 'context/AlertProvider';
import getUploadTypeDescription from 'modules/get-upload-type-description/get-upload-type-description';

export default function useFileTypeUploadWarning(group = '') {
  const alert = useAlert();

  useEffect(() => {
    const mustShowUploadFileTypeWarning = !JSON.parse(
      localStorage.getItem('uploadFileTypeWarning'),
    );

    if (mustShowUploadFileTypeWarning)
      alert.current.error(
        `Has logueado con un usuario del grupo <strong>${group.toUpperCase()}</strong>. Por favor, <strong>¡sube solo archivos ${getUploadTypeDescription(
          group,
        )}!</strong>`,
        () => {
          localStorage.setItem('uploadFileTypeWarning', 'true');
        },
      );
  }, [alert, group]);

  return group;
}
